import baseAPI from "@/http";

const router = "api/encontro-tipos";

export const encontrosTipoAPI = {
  create: (encontroTipo) => baseAPI.post(router, encontroTipo),
  update: (encontroTipo) => baseAPI.put(router, encontroTipo),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
};

const routerColour = "api/encontro-tipo-cores";

export const encontrosTipoCoresAPI = {
  create: (encontroTipo) =>
    baseAPI.post(`${routerColour}/salvar-cor`, encontroTipo),
  update: (encontroTipo) => baseAPI.put(routerColour, encontroTipo),
  listByUser: (userId) =>
    baseAPI.get(
      `${routerColour}/obter-encontros-tipo-por-usuario?id=${userId}`
    ),
  delete: (id) => baseAPI.delete(`${routerColour}/${id}`),
  list: () => baseAPI.get(routerColour),
};
